import { Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import { UtilsModule } from '../../../../utils/utils.module';

@Component({
  selector: 'app-common-column',
  templateUrl: './common-column.component.html',
  styleUrls: ['../parts.css']
})
export class CommonColumnComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 定时
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭
  // 条件列
  columnConditionDisplayText = '列'; // 列默认文字
  columnConditionData: any = null; // 列的值
  columnConditionVisible: boolean; // 条件列POP是否关闭
  columnConditionSelectList: Array<any> = []; // 条件列下拉列
  // 条件输入值
  inputConditionDisplayText = '值'; // 条件输入值默认文字
  inputConditionValue = ''; // 条件输入值默认值
  inputConditionVisible: boolean; // 条件输入值POP是否关闭
  // 分组条件
  groupConditionId = null; // 存放条件二选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID
  automation: any = {
    'boardId': '',
    'groupId': '',
    'categoryId': '',
    relationId: '',
    'schedulerConfig': {},
    'conditions': [],
    'taskMapping': {}
  }; // 存放入参数据
  @ViewChild('pulseIntegration') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private utilsModule: UtilsModule
  ) { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    // 初始化下拉项
    switch (this.categorieId) {
      case '1':
        this.columnConditionSelectList = [];
        this.boardColumnData.forEach((item, index) => {
          const obj = {
            'id': item.id,
            'title': item.title
          };
          this.columnConditionSelectList.push(obj);
        });
        break;
      case '2':
        break;
      case '3':
        this.columnConditionSelectList = [
          {'id': 'fundCode', 'title': '产品代码'},
          {'id': 'fundName', 'title': '产品名称'},
          {'id': 'fundManager', 'title': '管理人'}
        ];
        break;
    }
    // 处理返填数据
    if (JSON.stringify(this.instanceData) !== '{}') {
      this.backFillData = this.instanceData.config.taskMapping;
      // 反填定时
      this.schedulerConditionData = this.instanceData.config.schedulerConfig;
      this.schedulerConditionDisplayText =
        this.instanceData.config.schedulerDescription ? this.instanceData.config.schedulerDescription : '定时';
      // 反填列
      this.columnConditionDisplayText = this.instanceData.config.conditions[0].title;
      this.columnConditionData = this.instanceData.config.conditions[0].field;
      // 反填值
      this.inputConditionValue = this.instanceData.config.conditions[0].value;
      this.inputConditionDisplayText = this.instanceData.config.conditions[0].value;
      // 反填分组
      this.groupConditionId = this.instanceData.config.groupId;
      this.boardGroupData.forEach((item, index) => {
        if (item.id === this.groupConditionId) {
          this.groupConditionDisplayText = item.title;
        }
      });
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.packageData(this.automation);
    }
  }
  // 获取定时数据
  getSchedulerData(event) {
    this.schedulerConditionVisible = false;
    this.schedulerConditionDisplayText = event.text;
    this.schedulerConditionData = event.config;
    this.automation.schedulerDescription = this.schedulerConditionDisplayText;
    this.automation.schedulerConfig = this.schedulerConditionData;
    this.packageData(this.automation);
  }
  // 获取列数据
  columnConditionChange(event) {
    this.columnConditionDisplayText = event.title;
    this.columnConditionData = event.id;
    this.columnConditionVisible = false;
    const obj = {
      'field': this.columnConditionData,
      'title': this.columnConditionDisplayText,
      'operator': 'is',
      'value': this.inputConditionValue,
    };
    if (this.automation.conditions.length > 0) {
      this.automation.conditions = [];
      this.automation.conditions.push(obj);
    } else {
      this.automation.conditions.push(obj);
    }
    this.packageData(this.automation);
  }
  // 条件输入变更
  inputConditionChange(item) {
    this.inputConditionValue = item;
    this.inputConditionDisplayText = item;
    if (this.automation.conditions.length > 0) {
      this.automation.conditions[0].value = this.inputConditionValue;
    } else {
      const obj = {
        'field': this.columnConditionData,
        'title': this.columnConditionDisplayText,
        'operator': 'is',
        'value': this.inputConditionValue,
      };
      this.automation.conditions.push(obj);
    }
    this.packageData(this.automation);
  }
  // 条件输入回车
  inputConditionEnter() {
    this.inputConditionVisible = false;
  }
  // 条件分组变更
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = this.groupConditionId;
    this.packageData(this.automation);
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseIntegration.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    this.taskIntegrationData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping.mappingConfig = obj;
    });
    this.packageData(this.automation);
  }
  // 组件提交数据
  packageData(data) {
    const txt = this.schedulerConditionDisplayText ? `${this.schedulerConditionDisplayText.slice(0, 24)}...` : this.schedulerConditionDisplayText;
    const instanceDescription = txt + '，当' + this.columnConditionDisplayText + '的值等于' + this.inputConditionDisplayText + '时，在' + this.groupConditionDisplayText + '中，创建任务';
    data.instanceDescription = instanceDescription;
    this.nfDataChange.emit(data);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return JSON.stringify(this.automation.schedulerConfig) !== '{}' &&
      this.automation.conditions.length > 0 &&
      this.inputConditionValue &&
      this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
}
